import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const NxaFAQNxaMeets = () => {
  const [openQuestions, setOpenQuestions] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  // ✅ Corrected useEffect (moved outside the function)
  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth <= 768);
    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // ✅ Fixed toggleQuestion function
  const toggleQuestion = (index) => {
    setOpenQuestions((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div className="pricing-sec-1 pricing-page-faq">
      <div className="container">
        <h2 className="font--31 color-293F  fw--400">NxaTel Pricing FAQs</h2>
        <div className="row">
          {/* Question 1 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">1</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(1)}
                    aria-expanded={openQuestions[1]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What is included in the NxaMeets pricing plans?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[1] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Each plan includes HD video conferencing, screen sharing,
                    meeting recordings, chat, and advanced collaboration tools.
                    Higher-tier plans offer AI-powered transcriptions, webinar
                    hosting, and cloud storage for recorded meetings.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 2 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">2</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(2)}
                    aria-expanded={openQuestions[2]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Does NxaMeets offer a free trial?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[2] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes! We offer a 14-day free trial on selected plans. The
                    trial includes:
                    <ul style={{ listStyle: "disc", paddingLeft: "25px" }}>
                      <li>Full access to the NxaMeets platform</li>
                      <li>Up to 3 users</li>
                      <li>20 minutes of video calls per user</li>
                      <li>Limited cloud recording storage</li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 3 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">3</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(3)}
                    aria-expanded={openQuestions[3]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Are there any setup or installation fees?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[3] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    No! NxaMeets is cloud-based and requires no setup fees. You
                    can start using it instantly after signing up.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          {/* Question 4 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">4</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(4)}
                    aria-expanded={openQuestions[4]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Is there a contract or long-term commitment required?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[4] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    No, NxaMeets operates on a flexible, no-contract model,
                    allowing you to upgrade, downgrade, or cancel anytime.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 5 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">5</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(5)}
                    aria-expanded={openQuestions[5]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What payment methods does NxaMeets accept?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[5] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    We accept credit/debit cards, EFT, PayStack, Peach Payments,
                    and vouchers. Enterprise customers can request custom
                    billing solutions.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 6 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">6</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(6)}
                    aria-expanded={openQuestions[6]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Does NxaMeets offer volume discounts or bulk pricing?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[6] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes! Businesses with large teams or high usage needs can get
                    custom pricing. Contact our sales team to discuss bulk
                    discounts.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {/* Question 7 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">7</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(7)}
                    aria-expanded={openQuestions[7]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What happens if I exceed my plan’s meeting limits?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[7] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    If you exceed the participant or meeting duration limit, the
                    system will prompt an upgrade suggestion. Alternatively, you
                    can purchase add-on minutes or storage.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 8 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">8</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(8)}
                    aria-expanded={openQuestions[8]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Does NxaMeets support international video calls?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[8] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes! NxaMeets supports international video conferencing with
                    no extra fees. All plans include high-quality, low-latency
                    global connectivity.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 9 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">9</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(9)}
                    aria-expanded={openQuestions[9]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    How do I upgrade, downgrade, or cancel my plan?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[9] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Plan changes can be made instantly from your dashboard.
                    Upgrades take effect immediately, while cancellations may
                    require a 30-day notice depending on your plan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* partner logo */}
        <div className="sign-up-faq-partner-logo">
          <Link to="#" className="">
            <img src="./../assets/images/Method=Visa.svg" alt="logo" />
          </Link>
          <Link to="#" className="">
            <img src="./../assets/images/Mastercard.svg" alt="logo" />
          </Link>
          <Link to="#" className="">
            <img src="./../assets/images/Method=Stripe.svg" alt="logo" />
          </Link>
          <Link to="#" className="">
            <img src="./../assets/images/Ozwo Pay 1.svg" alt="logo" />
          </Link>
          {/* <Link to="#" className="">
            <img src="./../assets/images/voucher-log.svg" alt="logo" />
          </Link> */}
          {/* <Link to="#" className="">
            <img src="./../assets/images/blue-voucher.svg" alt="logo" />
          </Link> */}
          <Link to="#" className="">
            <img src="./../assets/images/nxa-voucher.svg" alt="logo" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NxaFAQNxaMeets;
